module.exports = __webpack_public_path__ + "static/media/JavaScript.0c1f700d.svg";